var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "users_filter" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "users_filter",
            "no-close-on-backdrop": true,
            dialogClass: "modal-dialog-right modal-lg",
            bodyClass: "p-0",
            "hide-footer": true,
            "hide-header": true,
            size: "xl",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function (ref) {
                var close = ref.close
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "outline-danger" },
                      on: {
                        click: function ($event) {
                          return close()
                        },
                      },
                    },
                    [_vm._v("\n                Close Modal\n            ")]
                  ),
                ]
              },
            },
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _vm.show_action
                    ? _c("b-spinner", { attrs: { variant: "success" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "xl", variant: "success" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.close_filter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.__t("ADD")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.is_show_modal,
            callback: function ($$v) {
              _vm.is_show_modal = $$v
            },
            expression: "is_show_modal",
          },
        },
        [
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "panel mb-0", attrs: { id: "panel_user_list" } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0 pt-2",
                  },
                  [
                    _c("h2", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.__t("CHOOSE_GROUP")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "panel-toolbar pr-3 mr-2 align-self-end" },
                      [
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs border-bottom-0",
                            attrs: { id: "demo_panel-tabs" },
                          },
                          [
                            _c(
                              "li",
                              {
                                staticClass: "nav-item cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.setTab(0)
                                  },
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: { active: _vm.tabIndex === 0 },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.__t("GROUP_LIST")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                staticClass: "nav-item cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.setTab(1)
                                  },
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: { active: _vm.tabIndex === 1 },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.__t("GROUP_SEARCH")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed pl-2",
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("i", { staticClass: "fal fa-times" })]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "panel-container show" }, [
                  _c(
                    "div",
                    { staticClass: "panel-content" },
                    [
                      _vm.tabIndex === 1 ? _c("search") : _vm._e(),
                      _vm._v(" "),
                      _vm.tabIndex === 0
                        ? _c("modifiers_groups_filter")
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-right w-100 position-absolute pos-bottom",
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-outline-primary waves-effect waves-themed mr-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.close_filter()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "fal fa-check mr-1" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("ADD")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-lg waves-effect waves-themed mr-3",
                    attrs: { size: "xl", variant: "outline-warning" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.close()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fal fa-times mr-1" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("CLOSE")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }